import { render, staticRenderFns } from "./PlotEdit.vue?vue&type=template&id=fa831c4c&"
import script from "./PlotEdit.vue?vue&type=script&lang=ts&"
export * from "./PlotEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PlotEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports